
/* ================================
   SLIDER CONTROLS
================================ */

// document.addEventListener("DOMContentLoaded", () => {

//   const slider = document.getElementById("cross-slider");
//   if (!slider) return;

//   const btnPrev = document.querySelector(".cross-nav.prev");
//   const btnNext = document.querySelector(".cross-nav.next");

//   function getCardWidth() {
//     const card = slider.querySelector(".cross-card-min");
//     return card ? card.offsetWidth + 14 : 260;
//   }

//   function updateNavState() {
//     const maxScroll = slider.scrollWidth - slider.clientWidth;

//     // PREV
//     if (slider.scrollLeft <= 5) {
//       btnPrev?.classList.add("disabled");
//       btnPrev?.classList.remove("active");
//     } else {
//       btnPrev?.classList.remove("disabled");
//       btnPrev?.classList.add("active");
//     }

//     // NEXT
//     if (slider.scrollLeft >= maxScroll - 5) {
//       btnNext?.classList.add("disabled");
//       btnNext?.classList.remove("active");
//     } else {
//       btnNext?.classList.remove("disabled");
//       btnNext?.classList.add("active");
//     }
//   }

//   btnNext?.addEventListener("click", () => {
//     slider.scrollLeft += getCardWidth() * 2;
//     setTimeout(updateNavState, 200);
//   });

//   btnPrev?.addEventListener("click", () => {
//     slider.scrollLeft -= getCardWidth() * 2;
//     setTimeout(updateNavState, 200);
//   });

//   slider.addEventListener("scroll", updateNavState);

//   // Initial state
//   updateNavState();
// });


/* ==========================================================
   CROSS SELL (Cart Drawer)
   - Nav arrows
   - Cross-sell Add to cart
   - Refresh drawer sections (no reload)
   - Force update <cart-count> text + attrs (fix mismatch)
========================================================== */
(function () {
  // prevent double init if file included twice
  if (window.__CROSS_SELL_DRAWER_INIT__) return;
  window.__CROSS_SELL_DRAWER_INIT__ = true;

  // ---------- helpers ----------
  function getDrawerControlsId() {
    // Your markup: aria-controls="MiniCart-sections--...__cart-drawer"
    return document.querySelector('.drawer__tab[aria-controls*="__cart-drawer"]')
      ?.getAttribute("aria-controls");
  }

  function forceSetCartCount(n) {
    document.querySelectorAll("cart-count").forEach((el) => {
      // visible number
      el.textContent = String(n);
      el.innerHTML = String(n);

      // accessibility + theme bindings
      el.setAttribute("aria-label", `${n} item${n === 1 ? "" : "s"}`);
      el.setAttribute("count", String(n));
      el.setAttribute("data-count", String(n));

      // in case component uses property
      try { el.count = n; } catch (e) {}
      try { el.value = n; } catch (e) {}

      if (n === 0) el.setAttribute("hidden", "");
      else el.removeAttribute("hidden");
    });
  }

  async function fetchCart() {
    return fetch("/cart.js", {
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
    }).then((r) => r.json());
  }

  async function syncCartCount() {
    const cart = await fetchCart();
    forceSetCartCount(cart.item_count);
    return cart;
  }

  // ---------- Refresh cart drawer + bubble via Sections Rendering ----------
  async function refreshMiniCartUI() {
    const controlsId = getDrawerControlsId(); // e.g. MiniCart-sections--...__cart-drawer
    const sectionLikeId = controlsId ? controlsId.replace(/^MiniCart-/, "") : null;

    // request both (some themes return by instance id, some by handle)
    const sectionIds = [sectionLikeId, "cart-drawer", "cart-icon-bubble"].filter(Boolean);
    const res = await fetch(`/?sections=${sectionIds.join(",")}`, {
      headers: { "Accept": "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) return;

    const sections = await res.json();

    // ---- replace drawer ----
    const drawerHtml = (sectionLikeId && sections[sectionLikeId]) || sections["cart-drawer"];
    if (drawerHtml) {
      const temp = document.createElement("div");
      temp.innerHTML = drawerHtml;

      // try to find new drawer element inside returned HTML
      const newDrawer =
        (controlsId && temp.querySelector(`#${CSS.escape(controlsId)}`)) ||
        (sectionLikeId && temp.querySelector(`#${CSS.escape(sectionLikeId)}`)) ||
        temp.querySelector('[id$="__cart-drawer"]') ||
        temp.querySelector("#CartDrawer") ||
        temp.firstElementChild;

      const oldDrawer =
        (controlsId && document.getElementById(controlsId)) ||
        (sectionLikeId && document.getElementById(sectionLikeId)) ||
        document.querySelector('[id$="__cart-drawer"]') ||
        document.querySelector("#CartDrawer");

      if (oldDrawer && newDrawer) oldDrawer.replaceWith(newDrawer);
    }

    // ---- replace cart icon bubble if exists ----
    const bubbleHtml = sections["cart-icon-bubble"];
    if (bubbleHtml) {
      const temp = document.createElement("div");
      temp.innerHTML = bubbleHtml;

      const newBubble =
        temp.querySelector("#cart-icon-bubble") || temp.firstElementChild;
      const oldBubble = document.querySelector("#cart-icon-bubble");

      if (oldBubble && newBubble) oldBubble.replaceWith(newBubble);
    }
  }

  // ---------- CROSS SELL ATC ----------
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(".cross-atc-btn");
    if (!btn) return;

    if (btn.disabled || btn.classList.contains("disabled")) return;
    e.preventDefault();

    const variantId = Number(btn.dataset.variantId || 0);
    if (!variantId) return;

    btn.disabled = true;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!res.ok) throw new Error(await res.text());

      // ✅ 1) refresh drawer html
      await refreshMiniCartUI();

      // ✅ 2) force count update (immediate)
      await syncCartCount();

      // ✅ 3) theme hydration overwrite hota hai, so re-apply after a moment
      setTimeout(() => { syncCartCount(); }, 200);
      setTimeout(() => { syncCartCount(); }, 600);

    } catch (err) {
      console.error("Cross-sell add failed:", err);
    } finally {
      btn.disabled = false;
    }
  });

  // ---------- NAV INIT ----------
  function initCrossSellNav(root = document) {
    const slider = root.querySelector("#cross-slider");
    if (!slider || slider.dataset.navInit === "1") return;

    const section = slider.closest(".cross-sell-section");
    if (!section) return;

    const btnPrev = section.querySelector(".cross-nav.prev");
    const btnNext = section.querySelector(".cross-nav.next");
    if (!btnPrev || !btnNext) return;

    slider.dataset.navInit = "1";

    function getStep() {
      const card = slider.querySelector(".cross-card-min");
      const gap = parseFloat(getComputedStyle(slider).gap) || 14;
      const w = card ? card.getBoundingClientRect().width : 260;
      return w + gap;
    }

    function updateNavState() {
      const maxScroll = slider.scrollWidth - slider.clientWidth;

      if (slider.scrollLeft <= 5) {
        btnPrev.classList.add("disabled");
        btnPrev.classList.remove("active");
      } else {
        btnPrev.classList.remove("disabled");
        btnPrev.classList.add("active");
      }

      if (slider.scrollLeft >= maxScroll - 5) {
        btnNext.classList.add("disabled");
        btnNext.classList.remove("active");
      } else {
        btnNext.classList.remove("disabled");
        btnNext.classList.add("active");
      }
    }

    btnNext.addEventListener("click", (e) => {
      e.preventDefault();
      slider.scrollBy({ left: getStep() * 2, behavior: "smooth" });
      setTimeout(updateNavState, 250);
    });

    btnPrev.addEventListener("click", (e) => {
      e.preventDefault();
      slider.scrollBy({ left: -getStep() * 2, behavior: "smooth" });
      setTimeout(updateNavState, 250);
    });

    slider.addEventListener("scroll", () => {
      clearTimeout(slider._navT);
      slider._navT = setTimeout(updateNavState, 80);
    });

    window.addEventListener("resize", updateNavState);
    updateNavState();
  }

  // init now
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCrossSellNav());
  } else {
    initCrossSellNav();
  }

  // re-init when drawer replaced
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.("#cross-slider") || node.querySelector?.("#cross-slider")) {
          initCrossSellNav(node);
          return;
        }
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

})();
